import { infiniteQueryOptions } from "@tanstack/react-query";
import { getUserId, meQueryOptions } from "./auth";
import { api, queryClient } from "./utils";

export const transactionsQueryKey = ["transactions"];

export const infiniteTransactionsQueryOptions = (userId: string) =>
  infiniteQueryOptions({
    queryKey: [...transactionsQueryKey, userId],
    queryFn: async ({ pageParam }) => {
      const response = await api.transactions.getTransactionsForMember({
        memberId: userId,
        pageNum: pageParam,
        pageSize: 25,
      });
      return response;
    },
    enabled: !!userId,
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage.has_more) return undefined;
      return allPages.length + 1;
    },
  });
export async function prefetchInfiniteTransactions() {
  await queryClient.prefetchQuery(meQueryOptions);
  const userId = getUserId();
  await queryClient.prefetchInfiniteQuery(infiniteTransactionsQueryOptions(userId));
}
